import React, { useState } from "react";
import "./NavbarM.css";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Home,
  LogOut,
  Menu,
  X,
  CreditCard,
  History,
  UserPlus,
  Search,
} from "lucide-react";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";

function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const storeName = localStorage.getItem("storeName") || "Store";

  const goTo = (path) => {
    setOpen(false);
    navigate(path, { replace: true });
  };

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      localStorage.clear();
      navigate("/", { replace: true });
    } catch (err) {
      console.error("Sign out error:", err);
      alert("Could not sign out. Please try again.");
    }
  };

  const isActive = (path) =>
    location.pathname.toLowerCase() === path.toLowerCase();

  return (
    <header className="ph-navbar">
      <div className="ph-navbar-inner">
        <button className="ph-brand" onClick={() => goTo("/Home")}>
          <div className="ph-logo">PH</div>
          <div>
            <h3>PointsHub</h3>
            <p>{storeName}</p>
          </div>
        </button>

        <button className="ph-menu-btn" onClick={() => setOpen(!open)}>
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>

        <nav className={`ph-nav-links ${open ? "show" : ""}`}>
          <button
            className={isActive("/Home") ? "active" : ""}
            onClick={() => goTo("/Home")}
          >
            <Home size={18} />
            Home
          </button>

          <button
            className={isActive("/SwipeCard") ? "active" : ""}
            onClick={() => goTo("/SwipeCard")}
          >
            <CreditCard size={18} />
            Swipe Card
          </button>

          <button
            className={isActive("/checkBalancePage") ? "active" : ""}
            onClick={() => goTo("/checkBalancePage")}
          >
            <Search size={18} />
            Check Balance
          </button>

          <button
            className={isActive("/TransactionHistoryPage") ? "active" : ""}
            onClick={() => goTo("/TransactionHistoryPage")}
          >
            <History size={18} />
            History
          </button>

          <button
            className={isActive("/AddMemberPage") ? "active" : ""}
            onClick={() => goTo("/AddMemberPage")}
          >
            <UserPlus size={18} />
            Add Member
          </button>

          <button className="signout-btn" onClick={handleSignOut}>
            <LogOut size={18} />
            Sign Out
          </button>
        </nav>
      </div>
    </header>
  );
}

export default Navbar;